import { config } from "../config";

export const getMediaURL = (objectKey: string) => {
    return `https://${config.storage}/${config.bucket}/${objectKey}`;
};